export const regexValidator = (regexStr:string) => {
    try {
      new RegExp(regexStr);
      return true;  // The regex is valid
    } catch (e) {
      return false;  // The regex is invalid
    }
  }